import { createContext, ReactNode, useContext, useReducer } from "react";
import { InitialContext } from "../types/state/context";
import {
  MasterArtworkSearch,
  MasterArtworkSearchActionTypes,
} from "../states/meta-artwork/search/data.type";
import { MasterArtworkSearchReducer } from "../states/meta-artwork/search";

type Context = InitialContext<
  MasterArtworkSearch,
  MasterArtworkSearchActionTypes
>;

export const MetaArtworkSearchContext = createContext<Context>({} as Context);

export const SearchMetaArtworkProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, dispatch] = useReducer(
    MasterArtworkSearchReducer.reducer,
    MasterArtworkSearchReducer.initialState,
  );

  return (
    <MetaArtworkSearchContext.Provider value={{ state, dispatch }}>
      {children}
    </MetaArtworkSearchContext.Provider>
  );
};

export const useMetaArtworkSearchStore = () => useContext(MetaArtworkSearchContext);
